import React from 'react';
import '../../styles/corpoClinico.css';
import SemFoto from '../../img/corpoClinico/sem_foto.jpg'
import PsicologaHumanista from '../../img/corpoClinico/psicologaHumanista_Luciana.jpg'
import PsicoHumanistaMarcos from '../../img/corpoClinico/psicologo_psicoterapeuta.jpg'

const CorpoClinico: React.FC = () => {
  return (
    <>
      <div className='title_clinic'>
        <h2 className="titulo" id="Corpo_Clinico_Psico_Humanista">Corpo Clínico</h2>
      </div>
      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={PsicoHumanistaMarcos} alt="Marcos" />
            </div>
            <div className="info-container">
              <h3 className="nome">Marcos Antonio dos Santos</h3>
              <a href="https://lattes.cnpq.br/3793773525515055"
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>
              <p className="descricao">
                "Psicólogo Clínico, Marcos Antonio dos Santos é psicólogo clínico (CRP 07/34049), mestrando em Psicologia pela PUCRS. Possui título de especialista em Psicologia Clínica pelo CFP e especializações em Psicologia Clínica (PUCRS), Saúde Mental e Atenção Psicossocial (UNESA) e Educação Ambiental (FURG). É graduado em Psicologia pela UNILASALLE, com ênfase em Prevenção e Promoção da Saúde, além de formação em Teologia e História. Atua com psicoterapia centrada na pessoa, oferecendo atendimentos presenciais e on-line para adultos e idosos, com foco no acolhimento e no cuidado humanizado."
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="space"><br /></div>
      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={PsicologaHumanista} alt="Luciane" />
            </div>
            <div className="info-container">
              <h3 className="nome">Luciane Silveira Silva</h3>
              {/*<a href="https://lattes.cnpq.br/3793773525515055"
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>*/}
              <p className="descricao">
                "Psicóloga Clínica
                Acompanhamento em Psicoterapia Cognitivo Comportamental, Aconselhamento
                Psicológico,  Avaliação e Reabilitação Neuropsicológica.
                Psicóloga que atua em psicoterapia cognitivo comportamental de crianças, adolescentes
                e idosos, aconselhamento psicológico de adolescentes e idosos e Avaliação e Reabilitação
                Neuropsicológica de 5 a 90 anos. Possui formação em Psicologia (UNILASALLE),
                especialização em Psicologia Clínica (PUC/RS), concluido especialização em
                Neuropsicologia (CBI OF MIAMI) entre demais certificações em cursos livres. Registro
                profissional no Conselho Regional de Psicologia CRP 07/26060."
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="botao-container">
        <br></br>
      </div>
    </>
  );
};

export default CorpoClinico;